import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";

export default function Unauthorized() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-[#F1F0FB] to-[#E5DEFF] px-2">
      <Card className="w-full max-w-md shadow-xl">
        <CardHeader>
          <div className="flex items-center gap-2 text-red-500">
            <AlertCircle size={24} />
            <CardTitle className="text-2xl font-semibold">No Autorizado</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600">
            No tienes permisos para acceder a esta página. Por favor, contacta al administrador si crees que esto es un error.
          </p>
        </CardContent>
      </Card>
    </div>
  );
} 